import { SUPPORTED_LOCALES, type Locale } from "./locale";
import type { AccountLocaleSync } from "./locale-sync.types";

/** Valor vindo da API é texto; só vale se for um idioma que a Tãmi fala. */
export function isSupportedLocale(value: unknown): value is Locale {
  return typeof value === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

/**
 * Concilia o idioma salvo na conta com o do aparelho ao entrar.
 *
 * A conta vence: a escolha feita em uma plataforma vale nas outras. Conta
 * sem idioma (criada antes da TAM-265, ou cadastro recém-feito) recebe o do
 * aparelho, que é o que a pessoa já está vendo — sem isso e-mail e push
 * sairiam no idioma padrão.
 */
export function reconcileAccountLocale(
  accountLocale: string | null | undefined,
  deviceLocale: Locale,
): AccountLocaleSync {
  if (!isSupportedLocale(accountLocale)) return { type: "save", locale: deviceLocale };
  if (accountLocale === deviceLocale) return { type: "none" };
  return { type: "apply", locale: accountLocale };
}

/**
 * Troca o idioma pelo "Gerenciar conta": grava na conta e só então aplica no
 * aparelho. Na ordem inversa, uma falha ao gravar deixaria o aparelho num
 * idioma e a conta noutro — e o próximo login (`reconcileAccountLocale`)
 * desfaria a escolha. Devolve `false` quando a gravação falhou.
 */
export async function changeAccountLocale(
  next: Locale,
  current: Locale,
  save: (locale: Locale) => Promise<void>,
  apply: (locale: Locale) => void,
): Promise<boolean> {
  if (next === current) return true;
  try {
    await save(next);
  } catch {
    return false;
  }
  apply(next);
  return true;
}
